class PurchaseOrderParams {
  constructor(
    poNumber,
    poType,
    state,
    brand,
    buyer,
    seller,
    currency,
    page_no,
    page_size,
    sort_by,
    sort_order,
    view_type,
    filter_date_on,
    start_date,
    end_date,
    options
  ) {
    this.poNumber = poNumber;
    this.poType = poType;
    this.state = state;
    this.brand = brand;
    this.buyer = buyer;
    this.seller = seller;
    this.currency = currency;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.view_type = view_type;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.options = options;
  }
}

class ASNParams {
  constructor(
    asnNumber,
    poNumber,
    invoiceNumber,
    state,
    warehouse,
    page_no,
    page_size,
    sort_by,
    sort_order,
    filter_date_on,
    start_date,
    end_date,
    brand,
    vendor,
    options
  ) {
    this.params = new CommonQueryParams(page_no, page_size, sort_by, sort_order);
    this.body = {
      asn_number: [asnNumber],
      brand: [brand],
      vendor: [vendor],
      po_number: [poNumber],
      invoice_number: [invoiceNumber],
      state: [state],
      warehouse: [warehouse],
      filter_date_on,
      start_date,
      end_date
    };
    this.options = options;
  }
}

class CommonQueryParams {
  constructor(page_no, page_size, sort_by, sort_order) {
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_order = sort_order;
    this.sort_by = sort_by;
  }
}

class GRNParams {
  constructor(
    grnType,
    grnNumber,
    poNumber,
    asnNumber,
    invoiceNumber,
    state,
    page_no,
    page_size,
    sort_by,
    sort_order,
    filter_date_on,
    start_date,
    end_date,
    options
  ) {
    this.grnType = grnType;
    this.grnNumber = grnNumber;
    this.poNumber = poNumber;
    this.asnNumber = asnNumber;
    this.invoiceNumber = invoiceNumber;
    this.state = state;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.options = options;
  }
}

class InternationalInventoryParams {
  constructor(page_no, page_size, sort_by, sort_order, options) {
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.options = options;
  }
}

class ASN_GRN_PO_search_params {
  constructor(
    poNumber,
    poType,
    state,
    buyerBillingId,
    buyerShippingId,
    sellerId,
    buyerBillingAddressId,
    buyerShippingAddressId,
    sellerAddressId,
    currency,
    page_no,
    page_size,
    sort_by,
    sort_order,
    view_type,
    filter_date_on,
    start_date,
    end_date
  ) {
    this.poNumber = poNumber;
    this.poType = poType;
    this.state = state;
    this.buyerBillingId = buyerBillingId;
    this.buyerShippingId = buyerShippingId;
    this.sellerId = sellerId;
    this.buyerBillingAddressId = buyerBillingAddressId;
    this.buyerShippingAddressId = buyerShippingAddressId;
    this.sellerAddressId = sellerAddressId;
    this.currency = currency;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.view_type = view_type;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
  }
}

class CommentsParams {
  constructor(
    referenceId,
    commentType,
    scanIdentifier,
    page_no,
    page_size,
    sort_by,
    sort_order,
    view_type,
    filter_date_on,
    start_date,
    end_date
  ) {
    this.referenceId = referenceId;
    this.commentType = commentType;
    this.scanIdentifier = scanIdentifier;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.view_type = view_type;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
  }
}

class AttachmentParams {
  constructor(
    fileName,
    referenceId,
    fileType,
    deleted,
    page_no,
    page_size,
    sort_by,
    sort_order,
    view_type,
    filter_date_on,
    start_date,
    end_date
  ) {
    this.fileName = fileName;
    this.referenceId = referenceId;
    this.fileType = fileType;
    this.deleted = deleted;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.view_type = view_type;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
  }
}

class MDM_Entity_params {
  constructor(entityCode, name, entityType, page_no, page_size, sort_by, sort_order) {
    this.entityCode = entityCode;
    this.name = name;
    this.entityType = entityType;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
  }
}

class Terms_Conditions_Params {
  constructor(type, title, body, page_no, page_size, sort_by, sort_order) {
    this.type = type;
    this.title = title;
    this.body = body;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
  }
}

class Brands_Params {
  constructor(name, prefix, page_no, page_size, sort_by, sort_order) {
    this.name = name;
    this.prefix = prefix;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
  }
}

class Sales_Order_Params {
  constructor(
    invoiceType,
    seller,
    buyer,
    poNumbers,
    soNumbers,
    state,
    brand,
    page_no,
    page_size,
    sort_by,
    sort_order,
    filter_date_on,
    start_date,
    end_date,
    options
  ) {
    this.invoiceType = invoiceType;
    this.seller = seller;
    this.buyer = buyer;
    this.poNumbers = poNumbers;
    this.soNumbers = soNumbers;
    this.state = state;
    this.brand = brand;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.options = options;
  }
}

class Sales_Purchase_Order_Params {
  constructor(
    poNumber,
    invoiceType,
    state,
    sellerId,
    buyerBillingId,
    brandId,
    page_no,
    page_size,
    sort_by,
    sort_order,
    filter_date_on,
    start_date,
    end_date,
    options
  ) {
    this.poNumber = poNumber;
    this.invoiceType = invoiceType;
    this.state = state;
    this.sellerId = sellerId;
    this.buyerBillingId = buyerBillingId;
    this.brandId = brandId;
    this.page_no = page_no;
    this.page_size = page_size;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.options = options;
  }
}

class Sales_GRN_Params {
  constructor(
    grnType,
    grnNumber,
    poNumber,
    soNumber,
    grnStatus,
    filter_date_on,
    start_date,
    end_date,
    sort_by,
    sort_order,
    page_no,
    page_size,
    options
  ) {
    this.grnType = grnType;
    this.grnNumber = grnNumber;
    this.poNumber = poNumber;
    this.soNumber = soNumber;
    this.grnStatus = grnStatus;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.page_no = page_no;
    this.page_size = page_size;
  }
}

class ROParams {
  constructor(
    grnType,
    grnNumber,
    poNumber,
    soNumber,
    grnStatus,
    filter_date_on,
    start_date,
    end_date,
    sort_by,
    sort_order,
    page_no,
    page_size,
    options
  ) {
    this.grnType = grnType;
    this.grnNumber = grnNumber;
    this.poNumber = poNumber;
    this.soNumber = soNumber;
    this.grnStatus = grnStatus;
    this.filter_date_on = filter_date_on;
    this.start_date = start_date;
    this.end_date = end_date;
    this.sort_by = sort_by;
    this.sort_order = sort_order;
    this.page_no = page_no;
    this.page_size = page_size;
    this.options = options;
  }
}

export {
  Brands_Params,
  MDM_Entity_params,
  PurchaseOrderParams,
  ASNParams,
  GRNParams,
  InternationalInventoryParams,
  ASN_GRN_PO_search_params,
  CommentsParams,
  AttachmentParams,
  Terms_Conditions_Params,
  Sales_Order_Params,
  Sales_Purchase_Order_Params,
  Sales_GRN_Params,
  ROParams
};
